import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

import TableWidget from "../../../components/tables/TableWidget";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

import {
  fetchDeliveredAwbHistory,
  fetchGetClientsNodes,
} from "../../../redux/api/expedition.api";

import { clearWorkingRoutesNodes } from "../../../redux/reducer/expedition.reducer";
import {
  deliveredAwbHistoryTableHeader,
  getDeliveredAwbHistoryTableData,
} from "./tableConfig/deliveredAwbHistoryTableConfig";

function DeliveredAwbHistory() {
  const dispatch = useAppDispatch();

  const {
    expedition: {
      deliveredAwbHistory: {
        data: {
          data: dataDeliveredAwbHistory,
          total: totalDeliveredAwbHistory,
        },
        isLoading: isLoadingDeliveredAwbHistory,
      },

      workingRoutesNodes: {
        data: { data: clientsNodesData },
        isLoading: isLoadingNodes,
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  useEffect(() => {
    dispatch(
      fetchGetClientsNodes({
        page: 1,
        perPage: 9999,
      }),
    );

    return () => {
      dispatch(clearWorkingRoutesNodes());
    };
  }, [dispatch]);

  const handleAwbTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch &&
      action.tableFilter
    ) {
      dispatch(
        fetchDeliveredAwbHistory({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          pctlivrare: action.tableSearch.pctlivrare,
          nodDestinatie: action.tableFilter.nodDestinatie,
          doc_trans: action.tableSearch.doc_trans,
          status: action.tableFilter.status,
          facturi: action.tableSearch.facturi,
        }),
      );
    }
  };

  const deliveredAwbHistoryTableHeaderNew = useMemo(
    () =>
      deliveredAwbHistoryTableHeader.map((item) => {
        if (!isLoadingNodes && item.value === "nodDestinatie") {
          const nodesDropdown =
            clientsNodesData?.map(({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            })) ?? [];

          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }
        return item;
      }),
    [clientsNodesData, isLoadingNodes],
  );

  return (
    <TableWidget
      tableTitle="Istoric colete livrate"
      tableHeaderData={deliveredAwbHistoryTableHeaderNew}
      tableItemsData={getDeliveredAwbHistoryTableData(dataDeliveredAwbHistory)}
      totalItems={totalDeliveredAwbHistory}
      tableLoading={isLoadingDeliveredAwbHistory}
      handleTableActions={handleAwbTableActions}
      borderedRow
    />
  );
}

export default DeliveredAwbHistory;
